import Table from './core/Table.js';

// Export main Table class as default
export default Table;

// Named exports for convenience
export { Table };

// Version info
export const version = '0.1.0';
